// Generated by config/esbuild.mjs - do not edit, regenerated on every build.
import Controller0 from "/app/app/javascript/controllers/tom_select_controller.js";
import Controller1 from "/app/app/javascript/controllers/role_types_controller.js";
import Controller2 from "/app/app/javascript/controllers/remote_autocomplete_controller.js";
import Controller3 from "/app/app/javascript/controllers/period_invoice_template_form_controller.js";
import Controller4 from "/app/app/javascript/controllers/password_toggle_controller.js";
import Controller5 from "/app/app/javascript/controllers/nested_form_controller.js";
import Controller6 from "/app/app/javascript/controllers/manual_deletion_controller.js";
import Controller7 from "/app/app/javascript/controllers/job_observation_notification_controller.js";
import Controller8 from "/app/app/javascript/controllers/globalized_fields_controller.js";
import Controller9 from "/app/app/javascript/controllers/forwarder_controller.js";
import Controller10 from "/app/app/javascript/controllers/form_field_inheritance_controller.js";
import Controller11 from "/app/app/javascript/controllers/form_field_check_dependent_controller.js";
import Controller12 from "/app/app/javascript/controllers/field_visibility_controller.js";
import Controller13 from "/app/app/javascript/controllers/field_remote_update_controller.js";
import Controller14 from "/app/app/javascript/controllers/field_multiplication_controller.js";
import Controller15 from "/app/app/javascript/controllers/field_addition_controller.js";
import Controller16 from "/app/app/javascript/controllers/disable_toggle_controller.js";
import Controller17 from "/app/app/javascript/controllers/autosubmit_controller.js";
import Controller18 from "/app/app/javascript/controllers/additional_address_controller.js";
import Controller19 from "/app/app/javascript/controllers/events/question_template_nested_form_controller.js";
import Controller20 from "/app/app/javascript/controllers/events/attachment_upload_controller.js";
import Controller21 from "/app/app/javascript/controllers/events/courses/group_filter_controller.js";
import Controller22 from "/app/app/components/steps_component_controller.js";

export function registerGeneratedControllers(application) {
  application.register("tom-select", Controller0);
  application.register("role-types", Controller1);
  application.register("remote-autocomplete", Controller2);
  application.register("period-invoice-template-form", Controller3);
  application.register("password-toggle", Controller4);
  application.register("nested-form", Controller5);
  application.register("manual-deletion", Controller6);
  application.register("job-observation-notification", Controller7);
  application.register("globalized-fields", Controller8);
  application.register("forwarder", Controller9);
  application.register("form-field-inheritance", Controller10);
  application.register("form-field-check-dependent", Controller11);
  application.register("field-visibility", Controller12);
  application.register("field-remote-update", Controller13);
  application.register("field-multiplication", Controller14);
  application.register("field-addition", Controller15);
  application.register("disable-toggle", Controller16);
  application.register("autosubmit", Controller17);
  application.register("additional-address", Controller18);
  application.register("events--question-template-nested-form", Controller19);
  application.register("events--attachment-upload", Controller20);
  application.register("events--courses--group-filter", Controller21);
  application.register("steps-component", Controller22);
}
